import { Controller } from "@hotwired/stimulus"
import lightGallery from "lightgallery"
import lgZoom from "lightgallery/plugins/zoom"
import "lightgallery/css/lightgallery.css"
import "lightgallery/css/lg-zoom.css"

export default class extends Controller {
  static targets = ["primary", "thumbnail"]

  connect() {
    this.gallery = lightGallery(this.element, {
      closable: true,
      closeOnTap: true,
      plugins: [lgZoom],
      selector: ".artwork-image--primary a",
      showCloseIcon: true,
      speed: 300,
      swipeToClose: true,
    })
  }

  disconnect() {
    if (this.gallery) {
      this.gallery.destroy()
      this.gallery = null
    }
  }

  swap(event) {
    const thumb = event.currentTarget
    const primary = this.primaryTarget
    const primaryImg = primary.querySelector("img")
    const primaryLink = primary.querySelector("a")

    primaryImg.src = thumb.dataset.fullSrc
    primaryImg.srcset = ""
    if (primaryLink) primaryLink.href = thumb.dataset.lightboxSrc

    this.thumbnailTargets.forEach(t => t.classList.remove("artwork-thumbnail--active"))
    thumb.classList.add("artwork-thumbnail--active")

    if (this.gallery) this.gallery.refresh()
  }
}
